// Buyer-facing "ships in N–M days" copy. Always returns something for
// curated AfriMarket items so we can confidently advertise speed against
// generic Africa-shipping competitors.
//
// Priority:
//   1. Listing-provided estimated_shipping_min_days/max_days (best)
//   2. Category default (curated catalogue heuristic)
//   3. null  (don't render anything)
//
// All numbers are in calendar days from order placement to UK/US/CA doorstep.
const CATEGORY_DEFAULT = {
  fashion: [7, 14],
  clothing: [7, 14],
  beauty: [5, 12],
  haircare: [5, 12],
  electronics: [10, 18],
  tech: [10, 18],
  home: [7, 14],
  homeware: [7, 14],
  food: [5, 10],
  grocery: [5, 10],
};
const DEFAULT_RANGE = [7, 14];

const categoryRange = (category) => {
  if (!category) return DEFAULT_RANGE;
  const key = String(category).toLowerCase();
  for (const [k, v] of Object.entries(CATEGORY_DEFAULT)) {
    if (key.includes(k)) return v;
  }
  return DEFAULT_RANGE;
};

/**
 * @param {object} listing
 * @param {object} opts { onlyIfCurated }
 * @returns {{ min:number, max:number, label:string } | null}
 */
export function shippingETA(listing, opts = {}) {
  if (!listing) return null;
  if (opts.onlyIfCurated && !listing.is_curated) return null;
  // Services aren't shipped — bail.
  if (listing.type === "service") return null;
  let min = Number(listing.estimated_shipping_min_days);
  let max = Number(listing.estimated_shipping_max_days);
  if (!Number.isFinite(min) || !Number.isFinite(max) || min <= 0 || max <= 0) {
    const fallback = categoryRange(listing.category);
    min = fallback[0];
    max = fallback[1];
  }
  if (max < min) max = min;
  return { min, max, label: `${min}–${max} days` };
}
